import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { FAQAccordion } from "@/components/FAQAccordion";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND, FAQ_HOME, SERVICES } from "@/data/site";
import { breadcrumbSchema, faqSchema, orgSchema } from "@/lib/schema";

const FAQPage = () => {
  const all = [...FAQ_HOME, ...SERVICES.flatMap((s) => s.faqs.slice(0, 2))];
  return (
    <Layout>
      <Seo
        title="FAQs | VRP Flooring LLC — Flooring Questions Answered"
        description="Answers to the most common flooring questions in Danbury, CT — pricing per square foot, installation timelines, subfloor prep, materials and warranties."
        jsonLd={[orgSchema(), faqSchema(all), breadcrumbSchema([{ name: "Home", url: BRAND.website }, { name: "FAQ", url: `${BRAND.website}/faq` }])]}
      />
      <section className="container-page py-12 md:py-16 max-w-3xl">
        <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "FAQ" }]} />
        <div className="mt-6 mb-10">
          <p className="eyebrow mb-4 text-accentInk">Frequently Asked</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold">Your flooring questions, answered.</h1>
        </div>
        <FAQAccordion items={all} />
        <div className="mt-12">
          <CTAGroup />
        </div>
      </section>
    </Layout>
  );
};
export default FAQPage;
